import styled from 'styled-components';

import { Card } from '@components/card';
import { PageContent } from '@components/page-containers/page-container';
import { MiddleColumnPage } from '@components/page-containers/page-containers';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useJourneyOverview } from 'api/journeys/hooks';

export const OverviewTab = ({ journeyShortId }: { journeyShortId: string }) => {
  const { t } = useScopedTranslate(locale);

  const journeyOverviewQuery = useJourneyOverview(journeyShortId);
  const timeSavedData = journeyOverviewQuery.data;

  return (
    <PageContent>
      <MiddleColumnPage>
        <Stack space={4}>
          <Stack space={2}>
            <Text font="bold18" text={t('timeSaved')} />
            <Text font="regular14" text={t('helpText')} />
          </Stack>
          <Separator />
          <Stack space={6} orientation="horizontal">
            <StyledCard spaceX={6} spaceY={4}>
              <Stack space={2}>
                <Text font="heading1" text={timeSavedData?.days.toString() ?? '0'} />
                <Text font="regular14" text={t('days')} />
              </Stack>
            </StyledCard>
            <StyledCard spaceX={6} spaceY={4}>
              <Stack space={2}>
                <Text font="heading1" text={timeSavedData?.hours.toString() ?? '0'} />
                <Text font="regular14" text={t('hours')} />
              </Stack>
            </StyledCard>
            <StyledCard spaceX={6} spaceY={4}>
              <Stack space={2}>
                <Text font="heading1" text={timeSavedData?.minutes.toString() ?? '0'} />
                <Text font="regular14" text={t('minutes')} />
              </Stack>
            </StyledCard>
          </Stack>
          <Separator />
          <Stack space={2}>
            <Text font="bold18" text={t('howCalculated')} />
            <Text font="regular14" text={t('calculatedText')} />
          </Stack>
        </Stack>
      </MiddleColumnPage>
    </PageContent>
  );
};

const StyledCard = styled(Card)({
  width: '100%',
});

const locale = {
  en: {
    timeSaved: 'Time Saved',
    helpText:
      'We estimate that each journey can save you a substantial amount of time for every action.',
    days: 'days',
    hours: 'hours',
    minutes: 'minutes',
    howCalculated: 'How is it calculated?',
    calculatedText:
      'The total time saved is based on either the default time assigned to each action type or a custom time selected for specific actions. That time is multiplied by the number of travellers who have completed those actions, and then summed across all completed actions in the journey.',
  },
};
